import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }
        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                // Clear hash from URL
                window.history.replaceState({}, document.title, window.location.pathname);
                setUser(data.user);
                if (!data.user.onboarded) navigate("/onboarding", { replace: true });
                else navigate("/dashboard", { replace: true });
            } catch {
                navigate("/login?error=oauth", { replace: true });
            }
        })();
    }, [location.hash, navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <div className="text-muted-foreground font-serif text-2xl tracking-wide">Welcoming you in…</div>
        </div>
    );
}
